<template>
  <div class="slider-banner">
    <!-- <div v-if="bannerFileNamesList.length > 0 && Object.keys(this.banners2).includes(this.language)"> -->
    <div v-if="bannerList.length > 0 && Object.keys(banners2).includes(mapLangFallback(language) || language)" :data-lang="language">
      <VueSlickCarousel v-bind="setting" :key="refreshNum">
        <div v-for="item in banners2[mapLangFallback(language) || language]" :key="item">
          <img :src="`/icon/banner/${item}`" alt="" />
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import { getBannerList } from '@/service/api/banner'
import VueSlickCarousel from 'vue-slick-carousel'
import { mapState } from 'vuex'
import Base from '@/mixins/base'
import { mapLang, bannerSort, bannerType, mapLangFallback } from '@/setting'

export default {
  name: 'banner',
  components: {
    VueSlickCarousel
  },
  mixins: [Base],
  data() {
    return {
      setting: {
        'dots': true,
        'arrows': false,
        'autoplay': true,
        'lazyLoad': 'ondemand'
      },
      banners: {}, // 整理 API 語系後的 banner 列表
      banners2: {}, // 整理 setting 語系後的 banner 列表
      refreshNum: 0,
      bannerFileNamesList: [], // 從 API 取得的 banner 排序
      bannerList: bannerSort, // 從 setting 取得的 banner 排序
    }
  },
  computed: {
    ...mapState({
      language: state => state.app.language,
      isLogin: state => state.user.isLogin
    })
  },
  watch: {
    language: {
      handler: function(val) {
        this.refreshNum = Math.random() // 語系有變更就重新渲染輪播
      },
      deep: true
    }
  },
  created() {
    this.getBanners()
    this.getBanners2()
  },
  mounted() {},
  methods: {
    mapLangFallback(lang) {
      return mapLangFallback[lang]
    },
    /**
     * 取得banner列表 (透過 API 設定 banner 順序)
     * @returns {Promise<void>}
     */
    async getBanners() {
      const res = await getBannerList()
      if (res.code === 200 && res.result.result.code === 1) {
        console.log('getBanners res:', res.result.rowsMap)
        let langKeys = [] // 語系
        let info = [] // 清單
        res.result.rowsMap.forEach((item) => {
          // console.log(item[0], item[1].fileNamesList)
          langKeys.push(item[0]) // 建語系列表
          info.push(item[1].fileNamesList) // 建內容
        })
        // console.log('langKeys', langKeys)
        // console.log('info', info)
        this.bannerFileNamesList = info
        for (let i = 0; i < langKeys.length; i++) {
          this.banners[langKeys[i]] = info[i]
          // this.banners[langKeys[i]] = this.sortArrayByOrder(info[i], true, bannerSort)
        }
        console.log('banners(API):', this.banners)
      } else {
        this.$message({
          message: `${res.result.result.msg}` + ` (${res.result.result.code})`,
          type: 'error'
        })
      }
    },
    /*
     * 取得banner列表（改由前端 setting 設定 banner 順序，不透過 API 設定）
     */
    getBanners2() {
      Object.keys(mapLang).forEach(langKey => {
        this.banners2[langKey] = []
      })
      bannerSort.forEach(banner => {
        Object.keys(mapLang).forEach(langKey => {
          this.banners2[langKey].push(`${banner}_${langKey}.${bannerType}`)
        })
      })
      console.log('banners(setting):', this.banners2)
    }
  }
}
</script>

<style lang="scss" scoped>
.slider-banner {
  img {
    width: 100%;
  }
}

@media screen and (max-width: 1023px) {
  .slider-banner {
    display: none;
  }
}
</style>
